import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { QUOTE_HIGHLIGHT_QUERY } from '../graphQL/quoteHighlightQuery';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import QuoteHighlightDetails from './QuoteHighlightDetails';
import { parseQuoteHighlightQueryResult } from '../graphQL/quoteHighlightQueryParser';
import QuoteHighlightActions from './QuoteHighlightActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHighlight = styled.div.withConfig({
  displayName: "QuoteHighlight__StyledHighlight",
  componentId: "sc-1fbkr5m-0"
})(["border-bottom:1px solid ", ";padding:24px 24px 0 24px;"], BATTLESHIP);
const QuoteHighlight = props => {
  const {
    objectId,
    permissions,
    closeSidebar
  } = props;
  const {
    data,
    loading,
    error
  } = useQuery(QUOTE_HIGHLIGHT_QUERY, {
    variables: {
      quoteId: objectId
    },
    fetchPolicy: 'network-only'
  });
  if (loading) {
    return /*#__PURE__*/_jsx(StyledHighlight, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        minHeight: 128
      })
    });
  }
  if (error || !data || !data.crmObject) {
    throw new Error('Error fetching quote highlight data');
  }
  const {
    quote,
    quoteEsign,
    userEmail,
    allowPayBeforeEsign
  } = parseQuoteHighlightQueryResult(data);
  return /*#__PURE__*/_jsxs("div", {
    className: "p-x-6 p-top-6 p-bottom-0",
    children: [/*#__PURE__*/_jsx(QuoteHighlightActions, {
      quote: quote,
      quoteEsign: quoteEsign,
      userEmail: userEmail,
      canCurrentUserEditQuote: permissions.canEditSubject,
      scopes: permissions.scopes,
      gates: permissions.gates,
      closeSidebar: closeSidebar
    }), /*#__PURE__*/_jsx(QuoteHighlightDetails, {
      quote: quote,
      allowPayBeforeEsign: allowPayBeforeEsign
    })]
  });
};
export default QuoteHighlight;